import { Controller } from "@hotwired/stimulus"

// Modale + wizard de création d'un bilan hebdomadaire.
//
// Étape 1 : choix du type (Ponctuel / Récurrent) via deux cartes.
// Étape 2 : le formulaire correspondant (un seul panel visible à la fois).
//
// La modale vit dans le DOM (cachée via l'attribut `hidden`). On l'ouvre
// depuis le bouton « Nouveau bilan », on la ferme via la croix, ESC ou clic
// sur le backdrop. Chaque panel a son propre <form> et son propre bouton de
// soumission ; le contrôleur ne fait que gérer la navigation et l'affichage
// conditionnel des champs de récurrence.
export default class extends Controller {
  static targets = ["modal", "typeStep", "detailsStep", "panel", "title", "dot"]
  static values  = { type: { type: String, default: "" } }

  // --- Ouverture / fermeture ------------------------------------------------

  open(event) {
    event?.preventDefault()
    this.reset()
    this.modalTarget.hidden = false
    this._previousOverflow = document.body.style.overflow
    document.body.style.overflow = "hidden"
    this.modalTarget.querySelector(".bil-typecard__btn")?.focus({ preventScroll: true })
  }

  close(event) {
    event?.preventDefault()
    this.modalTarget.hidden = true
    document.body.style.overflow = this._previousOverflow || ""
  }

  backdropClose(event) {
    if (event.target === this.modalTarget) this.close(event)
  }

  stopPropagation(event) { event.stopPropagation() }

  onKeydown(event) {
    if (event.key === "Escape" && !this.modalTarget.hidden) this.close(event)
  }

  // --- Navigation -----------------------------------------------------------

  chooseType(event) {
    event.preventDefault()
    const type = event.currentTarget.dataset.bilType
    this.typeValue = type

    this.panelTargets.forEach((p) => { p.hidden = p.dataset.bilType !== type })
    this.typeStepTarget.classList.remove("is-active")
    this.detailsStepTarget.classList.add("is-active")

    if (this.hasTitleTarget) {
      this.titleTarget.textContent = type === "recurrent" ? "Bilan récurrent" : "Bilan ponctuel"
    }
    this.setDots(1)

    const firstField = this.panelTargets
      .find((p) => p.dataset.bilType === type)
      ?.querySelector("select, input")
    firstField?.focus({ preventScroll: true })
  }

  back(event) {
    event?.preventDefault()
    this.detailsStepTarget.classList.remove("is-active")
    this.typeStepTarget.classList.add("is-active")
    if (this.hasTitleTarget) this.titleTarget.textContent = "Nouveau bilan"
    this.setDots(0)
  }

  reset() {
    this.typeValue = ""
    this.detailsStepTarget.classList.remove("is-active")
    this.typeStepTarget.classList.add("is-active")
    this.panelTargets.forEach((p) => { p.hidden = true })
    if (this.hasTitleTarget) this.titleTarget.textContent = "Nouveau bilan"
    this.setDots(0)
  }

  setDots(activeIndex) {
    this.dotTargets.forEach((dot, idx) => {
      dot.classList.toggle("is-active", idx === activeIndex)
      dot.classList.toggle("is-done", idx < activeIndex)
    })
  }

  // --- Affichage conditionnel des champs de récurrence ----------------------

  cadenceChanged(event) {
    const cadence = event.target.value
    const root = event.target.closest("[data-bil-type='recurrent']") || this.element
    root.querySelectorAll("[data-bil-cad]").forEach((block) => {
      const modes = block.dataset.bilCad.split(" ")
      block.hidden = !modes.includes(cadence)
    })
  }

  // --- Validation légère avant soumission -----------------------------------

  // Empêche de choisir deux fois le même membre dans le formulaire récurrent.
  validateRecurrent(event) {
    const form = event.target
    const a = form.querySelector("[name='bilan_schedule[membre_a_id]']")?.value
    const b = form.querySelector("[name='bilan_schedule[membre_b_id]']")?.value
    if (a && b && a === b) {
      event.preventDefault()
      window.alert("Choisis deux membres différents pour le bilan récurrent.")
    }
  }
}
